import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function PrivacyPage() {
  return <div className="min-h-screen bg-background text-textMain" data-id="element-6704">
      <header className="h-16 border-b border-border flex items-center px-6 bg-surface/50 backdrop-blur sticky top-0 z-50" data-id="element-6705">
        <Link to="/" className="flex items-center gap-2" data-id="element-6706">
          <span className="text-xl font-bold" data-id="element-6707">Booker</span>
          <div className="w-1.5 h-1.5 rounded-full bg-primary" data-id="element-6708"></div>
        </Link>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-3xl mx-auto px-6 py-16" data-id="element-6709">
        <h1 className="text-4xl font-bold mb-4" data-id="element-6710">Privacy Policy</h1>
        <p className="text-textMuted mb-12" data-id="element-6711">Last updated: April 6, 2026</p>

        <div className="prose prose-invert max-w-none space-y-8 text-textMuted" data-id="element-6712">
          <section data-id="element-6713">
            <h2 className="text-2xl font-bold text-textMain mb-4" data-id="element-6714">
              1. Information We Collect
            </h2>
            <p data-id="element-6715">
              We collect information you provide directly to us when you create
              an account, update your profile, use the platform to manage
              bookings, or communicate with us. This includes name, email,
              payment information, and operational data (contacts, contracts,
              schedules).
            </p>
          </section>

          <section data-id="element-6716">
            <h2 className="text-2xl font-bold text-textMain mb-4" data-id="element-6717">
              2. How We Use Your Information
            </h2>
            <p data-id="element-6718">
              We use the information we collect to provide, maintain, and
              improve our services, process transactions, send administrative
              messages, and provide customer support. We do not sell your
              personal data or your contact lists to third parties.
            </p>
          </section>

          <section data-id="element-6719">
            <h2 className="text-2xl font-bold text-textMain mb-4" data-id="element-6720">
              3. Data Sharing and Disclosure
            </h2>
            <p data-id="element-6721">
              We may share your information with third-party vendors and service
              providers that perform services on our behalf (such as payment
              processing via Stripe, or email delivery via SendGrid). When you
              use Booker to send contracts or outreach, relevant information is
              shared with the recipient.
            </p>
          </section>

          <section data-id="element-6722">
            <h2 className="text-2xl font-bold text-textMain mb-4" data-id="element-6723">
              4. Data Security
            </h2>
            <p data-id="element-6724">
              We implement appropriate technical and organizational measures to
              protect the security of your personal information, including
              encryption of data in transit and at rest.
            </p>
          </section>

          <section data-id="element-6725">
            <h2 className="text-2xl font-bold text-textMain mb-4" data-id="element-6726">
              5. Your Rights
            </h2>
            <p data-id="element-6727">
              You may access, update, or delete your account information at any
              time through your account settings. You may also contact us to
              request access to, correction of, or deletion of personal
              information.
            </p>
          </section>
        </div>
      </motion.div>
    </div>;
}